<template>
    <div class="pin-input">
        <AccountInput
            class="pin-input__enter"
            :errorMessage="errorMessage"
            :name="name"
            @inputErrorDetected="emit('inputErrorDetected', name, errorMessage)"
        >
            <div class="pin-input__fields">
                <input
                    class="pin-input__field-input"
                    type="text"
                    inputmode="numeric"
                    placeholder=""
                    maxlength="1"
                    v-for="(_, index) in inputValues"
                    :key="'pin-input' + index"
                    ref="inputRefs"
                    v-model="inputValues[index].value"
                    @keydown="(event) => keyDownEventHandler(event, index)"
                    @keyup="(event) => keyUpEventHandler(event, index)"
                />
            </div>
        </AccountInput>

        <div class="pin-input__info">
            Na
            <span v-if="phoneNumber">
                číslo
                <b>{{ phoneNumberFormatted }}</b>
            </span>
            <span v-else> vaše číslo </span>
            jsme odeslali 4místný PIN kód. Zadejte ho prosím.
        </div>

        <div class="pin-input__resend-container">
            <div v-if="!pinResendedInternal" class="pin-input__resend">
                Kód mi nepřišel. <a @click="resendPin" class="pin-input__resend-link">Odeslat znovu</a>
            </div>
            <div v-else-if="pinResendedInternal && pinResendedSuccess" class="pin-input__resend-success">ODESLÁNO</div>
            <div v-else class="pin-input__resend-fail">ODESLÁNÍ SELHALO</div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, watch } from "vue";
import AccountInput from "./account-input.vue";

const emit = defineEmits<{
    /* eslint-disable @typescript-eslint/naming-convention */
    "update:modelValue": [newValue: string];
    resendPin: [];
    inputErrorDetected: [fieldName: string, errorMessage: string];
}>();

const props = defineProps<{
    modelValue: string;
    name: string;
    phoneNumber: string;
}>();

const phoneNumberFormatted = computed(() => {
    const number = props.phoneNumber;
    if (!number) return "";
    return number.slice(0, 4) + " " + number.slice(4, 7) + " " + number.slice(7, 10) + " " + number.slice(10, 13);
});

const inputValues = [ref(""), ref(""), ref(""), ref("")];

const inputRefs = ref<HTMLInputElement[]>([]);

const getCode = () =>
    inputValues.map((inputValueRef) => inputValueRef.value).reduce((prevValue, inputValue) => prevValue + inputValue);

/*  MUST BE CRAZY SOLUTION BECAUSE OLD ANDROIND IS SHIT -> dont support key detection. */
watch(
    () => inputValues,
    () => {
        emit("update:modelValue", getCode());
    },
    {
        deep: true,
    }
);

let isSecondLetter = false;
const enabledKeys = ["Unidentified", "Delete", "Backspace", "ArrowLeft", "ArrowRight", "Tab"];
const keyDownEventHandler = (event: KeyboardEvent, index: number) => {
    console.log(event, index);
    if ((event.key < "0" || event.key > "9") && !enabledKeys.find((enabledKey) => enabledKey == event.key)) {
        event.preventDefault();
    }

    isSecondLetter = inputRefs.value[index].selectionStart > 0;
};

const keyUpEventHandler = (event: KeyboardEvent, index: number) => {
    if (event.key == "Delete" || event.key == "Backspace") {
        if (index > 0) {
            inputRefs.value[index - 1].setSelectionRange(1, 1);
            inputRefs.value[index - 1].focus();
        }
    } else if ((event.key >= "0" && event.key <= "9") || event.key == "Unidentified") {
        if (event.key >= "0" && event.key <= "9") {
            if (isSecondLetter) {
                inputValues[index + 1].value = event.key;
            } else if (inputValues[index].value != event.key) {
                inputValues[index].value = event.key;
            }
        }

        if (index < inputRefs.value.length - 1) {
            inputRefs.value[index + 1].setSelectionRange(0, 0);
            inputRefs.value[index + 1].focus();
        } else {
            inputRefs.value[index].blur();
        }
    }
};

/* ****************** END CRAZY SOLUTION ********************* */

const resendPin = () => {
    emit("resendPin");
};

const pinResendedInternal = ref(false);
const pinResendedSuccess = ref(false);
const pinResended = (success: boolean) => {
    pinResendedInternal.value = true;
    pinResendedSuccess.value = success;
};

onMounted(() => {
    inputRefs.value[0].focus();
});

const checkCode = (code: string) => /^(\d{4})$/.test(code);

const errorMessage = defineModel<string>("errorMessage");

const checkIfIsValid = (): boolean => {
    let isValid = true;

    const code = getCode();

    if (!code) {
        errorMessage.value = "Vyplňte prosím kód.";
        isValid = false;
    } else if (!checkCode(code)) {
        errorMessage.value = "Pin není zadaný správně.";
        isValid = false;
    }

    return isValid;
};

defineExpose({
    pinResended,
    checkIfIsValid,
});
</script>
